import type {OwnerReportCard} from './product-types';

// Match declared identities, never a card's position or words in its title.
export function reportForKind(reports:readonly OwnerReportCard[],kind:string,businessDate?:string):OwnerReportCard|null{
  const fixed=reports.find(report=>{
    const id=report.reportId.toUpperCase();
    return id===kind||id.startsWith(kind+'-')||id.startsWith(kind+'_');
  });
  if(fixed)return fixed;
  if(kind==='R1'&&businessDate&&/^\d{4}-\d{2}-\d{2}$/.test(businessDate)){
    return reports.find(report=>report.reportId==='daily:'+businessDate)??null;
  }
  return null;
}

export function reportDateLabel(report:OwnerReportCard,businessDate?:string){
  const daily=/^daily:(\d{4}-\d{2}-\d{2})$/.exec(report.reportId);
  return daily?.[1]??businessDate??'日期未提供';
}
